import type { App, Plugin } from 'vue'
import { createI18nConfig, fetchLocales } from './i18n'
import { DelphiErrorPlugin } from './plugin-error'
import { createPinia } from 'pinia'

/**
 * Install plugins used by all vue apps
 *
 * “One Plugin to rule them all,
 * One Plugin to find them,
 * One Plugin to bring them all.
 * And in the darkness bind them.”
 */
export const DelphiPluginLoader = async (): Promise<Plugin> => {
  // Pre-load locales
  await fetchLocales()
  const i18n = createI18nConfig()

  const VueCommonPlugins: Plugin = {
    async install(app: App) {
      app.use(DelphiErrorPlugin)
      app.use(i18n)
      app.use(createPinia())
    },
  }

  return VueCommonPlugins
}
